export enum MapPointKind { unknown, from, to }